import {
  SET_DEFAULT_TEXTS,
  SET_MODAL_VISIBLE,
  USER_TEXTS_GENERATED,
  MODAL_CLOSED } from '../../action-types/ui/babyPage';

export const STATE_KEY = 'babyPageProperties';

export const babyPageProperties = (state = {
  setDefaultTexts: false,
  setModalVisible: false,
  userTextsGenerated: false,
  modalClosed: false,
}, action) => {
  switch (action.type) {
    case SET_DEFAULT_TEXTS: {
      const { status } = action;
      return Object.assign({}, state, { setDefaultTexts: status });
    }
    case SET_MODAL_VISIBLE: {
      const { status } = action;
      return Object.assign({}, state, { setModalVisible: status });
    }
    case USER_TEXTS_GENERATED: {
      const { status } = action;
      return Object.assign({}, state, { userTextsGenerated: status });
    }
    case MODAL_CLOSED: {
      const { status } = action;
      return Object.assign({}, state, { modalClosed: status });
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/ui/babyPage.js